import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import RemoveOption from 'app/React/Components/Footer/RemoveOption'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export function DisplayPrice({ option }) {
  const {
    currentVariant,
    order
  } = useContext(ConfiguratorContext)

  const showPrice = Boolean(Number(currentVariant.show_price ?? null))

  if (order.paymentType !== 'leasing' || !(option.use_leasing_price && option.use_leasing_price !== '0')) {
    if (typeof option.price !== 'undefined' && option.price > 0 && showPrice) {
      return (
        <>
          <RemoveOption option={option} price={option.price} format='cash'/>
        </>
      )
    } else {
      return (
        <>
          <RemoveOption option={option} price={null}/>
        </>
      )
    }
  } else {
    if (typeof option.price_leasing !== 'undefined' && option.price_leasing > 0) {
      return (
        <>
          <RemoveOption option={option} price={option.price_leasing}/>
        </>
      )
    } else {
      return (
        <>
          <RemoveOption option={option} price={null}/>
        </>
      )
    }
  }
  return null
}

DisplayPrice.propTypes = {
  option: PropTypes.shape({
    use_leasing_price: PropTypes.any,
    price: PropTypes.any,
    price_leasing: PropTypes.any
  }).isRequired
}
